import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { theme } from "styles/theme";
import { useOnboardingProgress } from "hooks/useOnboardingProgress";
import { usePrevious } from "hooks/usePrevious";

import useMixpanelMKT from "hooks/useMixpanelMKT";
import Start_1_Promotion from "pages/onboarding/partPromotion/acquisition/Start_1_Promotion";
import Demographic_1_Promotion from "pages/onboarding/partPromotion/demographic/Demographic_1_Promotion";
import Demographic_2_Promotion from "pages/onboarding/partPromotion/demographic/Demographic_2_Promotion";
import Demographic_3_Promotion from "pages/onboarding/partPromotion/demographic/Demographic_3_Promotion";
import Demographic_4_Promotion from "pages/onboarding/partPromotion/demographic/Demographic_4_Promotion";
import FullPageWithHeaderAndProgressTmp from "pages/container/FullPageWithHeaderAndProgressTmp";
import FullPageWithCenterContentV2 from "pages/container/FullPageWithCenterContentV2";
import Goal_1_Promotion from "pages/onboarding/partPromotion/goal/Goal_1_Promotion";
import Goal_2_MultiSelect_1_Promotion from "pages/onboarding/partPromotion/goal/Goal_2_MultiSelect_1_Promotion";
import Goal_3_MultiSelect_2_Promotion from "pages/onboarding/partPromotion/goal/Goal_3_MultiSelect_2_Promotion";
import Goal_4_Promotion from "pages/onboarding/partPromotion/goal/Goal_4_Promotion";
import Goal_5_Promotion from "pages/onboarding/partPromotion/goal/Goal_5_Promotion";
import Goal_6_Promotion from "pages/onboarding/partPromotion/goal/Goal_6_Promotion";
import Goal_7_Promotion from "pages/onboarding/partPromotion/goal/Goal_7_Promotion";
import Goal_8_Promotion from "pages/onboarding/partPromotion/goal/Goal_8_Promotion";
import Goal_10_Promotion from "pages/onboarding/partPromotion/goal/Goal_10_Promotion";
import Goal_11_Promotion from "pages/onboarding/partPromotion/goal/Goal_11_Promotion";
import Goal_9_Promotion from "pages/onboarding/partPromotion/goal/Goal_9_Promotion";
import Goal_12_Promotion from "pages/onboarding/partPromotion/goal/Goal_12_Promotion";
import Convention_1_Promotion from "pages/onboarding/partPromotion/convention/Convention_1_Promotion";
import Convention_2_QnA_Promotion from "pages/onboarding/partPromotion/convention/Convention_2_QnA_Promotion";
import Convention_3_Promotion from "pages/onboarding/partPromotion/convention/Convention_3_Promotion";
import Habit_1_Promotion from "pages/onboarding/partPromotion/habit/Habit_1_Promotion";
import Habit_2_QnA_Promotion from "pages/onboarding/partPromotion/habit/Habit_2_QnA_Promotion";
import Habit_3_Promotion from "pages/onboarding/partPromotion/habit/Habit_3_Promotion";
import Habit_4_Promotion from "pages/onboarding/partPromotion/habit/Habit_4_Promotion";
import Habit_5_Promotion from "pages/onboarding/partPromotion/habit/Habit_5_Promotion";
import Habit_6_Promotion from "pages/onboarding/partPromotion/habit/Habit_6_Promotion";
import Habit_7_Promotion from "pages/onboarding/partPromotion/habit/Habit_7_Promotion";
import Motivation_1_Promotion from "pages/onboarding/partPromotion/motivation/Motivation_1_Promotion";
import Motivation_2_Promotion from "pages/onboarding/partPromotion/motivation/Motivation_2_Promotion";
import Motivation_3_Promotion from "pages/onboarding/partPromotion/motivation/Motivation_3_Promotion";
import Motivation_4_Promotion from "pages/onboarding/partPromotion/motivation/Motivation_4_Promotion";
import Motivation_5_Promotion from "pages/onboarding/partPromotion/motivation/Motivation_5_Promotion";
import Motivation_6_Promotion from "pages/onboarding/partPromotion/motivation/Motivation_6_Promotion";
import Motivation_7_MultiSelect_Promotion from "pages/onboarding/partPromotion/motivation/Motivation_7_MultiSelect_Promotion";
import Motivation_8_Promotion from "pages/onboarding/partPromotion/motivation/Motivation_8_Promotion";
import Result_1_Promotion from "pages/onboarding/partPromotion/result/Result_1_Promotion";
import Result_2_Promotion from "pages/onboarding/partPromotion/result/Result_2_Promotion";
import Result_3_Promotion from "pages/onboarding/partPromotion/result/Result_3_Promotion";
import Result_4_Promotion from "pages/onboarding/partPromotion/result/Result_4_Promotion";
import { readLastStep, writeLastStep } from "utils/promotionOnboardingStorage";
import ProductContentPageV5 from "./ProductContentPageV5";
import Start_4_Promotion from "../../../../pages/onboarding/partPromotion/acquisition/Start_4_Promotion";
import Start_3_Promotion from "../../../../pages/onboarding/partPromotion/acquisition/Start_3_Promotion";
import Start_2_Promotion from "../../../../pages/onboarding/partPromotion/acquisition/Start_2_Promotion";

interface OnboardingStep {
  type: string;
  seqByType: number;
  title?: string;
  hideHeader?: boolean;
  hideProgress?: boolean;
  disableBack?: boolean;
  progressDelta?: number;
  centerFullScreen?: boolean;
  backgroundColor?: string;
  highlightBackground?: boolean;
  content: React.ReactNode;
}

const commonPrefixSteps: OnboardingStep[] = [
  {
    type: "start",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <Start_1_Promotion version={"v5"} />,
  },
  {
    type: "start",
    seqByType: 2,
    hideProgress: true,
    content: <Start_2_Promotion version={"v5"} />,
  },
  {
    type: "start",
    seqByType: 3,
    hideProgress: true,
    content: <Start_3_Promotion version={"v5"} />,
  },
  {
    type: "start",
    seqByType: 4,
    hideProgress: true,
    content: <Start_4_Promotion version={"v5"} />,
  },
];

const demographicSteps: OnboardingStep[] = [
  {
    type: "demographic",
    seqByType: 1,
    title: "기본 정보",
    progressDelta: 1 / 4,
    disableBack: true,
    content: <Demographic_1_Promotion version={"v5"} />,
  },
  {
    type: "demographic",
    seqByType: 2,
    title: "기본 정보",
    progressDelta: 2 / 4,
    content: <Demographic_2_Promotion version={"v5"} />,
  },
  {
    type: "demographic",
    seqByType: 3,
    title: "기본 정보",
    progressDelta: 3 / 4,
    content: <Demographic_3_Promotion version={"v5"} />,
  },
  {
    type: "demographic",
    seqByType: 4,
    title: "기본 정보",
    progressDelta: 4 / 4,
    content: <Demographic_4_Promotion version={"v5"} />,
  },
];

const mainContentSteps: OnboardingStep[] = [
  {
    type: "goal",
    seqByType: 1,
    title: "고민과 목표",
    disableBack: true,
    progressDelta: 1 / 7,
    content: <Goal_1_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 2,
    title: "고민과 목표",
    progressDelta: 2 / 7,
    content: <Goal_2_MultiSelect_1_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 3,
    title: "고민과 목표",
    progressDelta: 3 / 7,
    content: <Goal_3_MultiSelect_2_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 4,
    hideProgress: true,
    highlightBackground: true,
    content: <Goal_4_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 5,
    title: "고민과 목표",
    progressDelta: 4 / 7,
    content: <Goal_5_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 6,
    title: "고민과 목표",
    progressDelta: 5 / 7,
    content: <Goal_6_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 7,
    hideProgress: true,
    highlightBackground: true,
    content: <Goal_7_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 8,
    hideProgress: true,
    highlightBackground: true,
    content: <Goal_8_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 9,
    title: "고민과 목표",
    progressDelta: 6 / 7,
    content: <Goal_9_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 10,
    hideProgress: true,
    content: <Goal_10_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 11,
    hideHeader: true,
    hideProgress: true,
    content: <Goal_11_Promotion version={"v5"} />,
  },
  {
    type: "goal",
    seqByType: 12,
    hideProgress: true,
    highlightBackground: true,
    content: <Goal_12_Promotion version={"v5"} />,
  },
  {
    type: "convention",
    seqByType: 1,
    title: "인식과 기대",
    disableBack: true,
    progressDelta: 1 / 12,
    content: <Convention_1_Promotion version={"v5"} />,
  },
  {
    type: "convention",
    seqByType: 2,
    title: "인식과 기대",
    progressDelta: 1 / 12,
    content: <Convention_2_QnA_Promotion version={"v5"} />,
  },
  {
    type: "convention",
    seqByType: 3,
    hideProgress: true,
    highlightBackground: true,
    content: <Convention_3_Promotion version={"v5"} />,
  },
  {
    type: "habit",
    seqByType: 1,
    title: "습관과 노력",
    disableBack: true,
    progressDelta: 1 / 7,
    content: <Habit_1_Promotion version={"v5"} />,
  },
  {
    type: "habit",
    seqByType: 2,
    title: "습관과 노력",
    progressDelta: 1 / 7,
    content: <Habit_2_QnA_Promotion version={"v5"} />,
  },
  {
    type: "habit",
    seqByType: 3,
    hideProgress: true,
    content: <Habit_3_Promotion version={"v5"} />,
  },
  {
    type: "habit",
    seqByType: 4,
    hideHeader: true,
    hideProgress: true,
    content: <Habit_4_Promotion version={"v5"} />,
  },
  {
    type: "habit",
    seqByType: 5,
    hideProgress: true,
    highlightBackground: true,
    content: <Habit_5_Promotion version={"v5"} />,
  },
  {
    type: "habit",
    seqByType: 6,
    hideProgress: true,
    highlightBackground: true,
    content: <Habit_6_Promotion version={"v5"} />,
  },
  {
    type: "habit",
    seqByType: 7,
    hideProgress: true,
    highlightBackground: true,
    content: <Habit_7_Promotion version={"v5"} />,
  },
  {
    type: "motivation",
    seqByType: 1,
    title: "의지와 동기",
    disableBack: true,
    progressDelta: 1 / 6,
    content: <Motivation_1_Promotion version={"v5"} />,
  },
  {
    type: "motivation",
    seqByType: 2,
    title: "의지와 동기",
    progressDelta: 2 / 6,
    content: <Motivation_2_Promotion version={"v5"} />,
  },
  {
    type: "motivation",
    seqByType: 3,
    title: "의지와 동기",
    progressDelta: 3 / 6,
    content: <Motivation_3_Promotion version={"v5"} />,
  },
  {
    type: "motivation",
    seqByType: 4,
    hideProgress: true,
    highlightBackground: true,
    content: <Motivation_4_Promotion version={"v5"} />,
  },
  {
    type: "motivation",
    seqByType: 5,
    title: "의지와 동기",
    progressDelta: 4 / 6,
    content: <Motivation_5_Promotion version={"v5"} />,
  },
  {
    type: "motivation",
    seqByType: 6,
    hideProgress: true,
    highlightBackground: true,
    content: <Motivation_6_Promotion version={"v5"} />,
  },
  {
    type: "motivation",
    seqByType: 7,
    title: "의지와 동기",
    progressDelta: 5 / 6,
    content: (
      <Motivation_7_MultiSelect_Promotion
        hideNextButton={false}
        version={"v5"}
      />
    ),
  },
  {
    type: "motivation",
    seqByType: 8,
    hideProgress: true,
    highlightBackground: true,
    content: <Motivation_8_Promotion version={"v5"} />,
  },
];

const resultContentSteps: OnboardingStep[] = [
  {
    type: "result",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <Result_1_Promotion version={"v5"} />,
  },
  {
    type: "result",
    seqByType: 2,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Surface.Highlight,
    content: <Result_2_Promotion version={"v5"} />,
  },
  {
    type: "result",
    seqByType: 3,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Result_3_Promotion version={"v5"} />,
  },
  {
    type: "result",
    seqByType: 4,
    hideHeader: true,
    hideProgress: true,
    content: <Result_4_Promotion version={"v5"} />,
  },
  {
    type: "product",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <></>,
  },
];

function findIndexByStepInfo(
  steps: OnboardingStep[],
  type: string,
  seqByType: number
): number {
  return steps.findIndex(
    (step) => step.type === type && step.seqByType === seqByType
  );
}
export function findStep(
  steps: OnboardingStep[],
  type: string,
  seqByType: number
): OnboardingStep {
  return steps[findIndexByStepInfo(steps, type, seqByType)];
}

export default function OnboardingScreenV5() {
  const { type, id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const steps = useMemo(() => {
    return [
      ...commonPrefixSteps,
      ...demographicSteps,
      ...mainContentSteps,
      ...resultContentSteps,
    ];
  }, []);

  const numId = parseInt(id || "0");
  const questionNumber = searchParams.get("q");

  const currentStepIndex = Math.min(
    Math.max(findIndexByStepInfo(steps, type!!, numId), 0),
    steps.length - 1
  ); // 유효한 범위 내로 제한

  const currentStep = steps[currentStepIndex];
  const prevStepIndex = usePrevious(currentStepIndex);

  const trackingParams = useMemo(
    () => ({
      type: `${currentStep.type}`,
      pageId: `${currentStep.seqByType}`,
    }),
    [currentStep.type, currentStep.seqByType]
  );

  const trackPromotion = useMixpanelMKT({
    eventName: "온보딩 페이지 진입",
    params: trackingParams,
    version: "v5",
  });

  useEffect(() => {
    if (type === "load") return;
    if (type === "product") return;

    // 이벤트 전송
    trackPromotion();
  }, [type, id]);

  // 마지막으로 본 페이지 저장 (load/start/product 제외)
  useEffect(() => {
    if (!type || !id) return;
    if (type === "load" || type === "product" || type === "start") return;
    try {
      writeLastStep({
        type,
        seqByType: parseInt(id, 10),
        q: questionNumber ? parseInt(questionNumber, 10) : undefined,
      });
    } catch (_) {
      // noop
    }
  }, [type, id, questionNumber]);

  // /v5-onboarding/start/1 진입 시 마지막으로 보던 페이지로 복구
  useEffect(() => {
    if (type !== "start" || id !== "1") return;

    // 뒤로 가기(인덱스가 감소)해서 도달한 경우에는 리다이렉트 하지 않음
    if (
      prevStepIndex !== undefined &&
      (prevStepIndex as number) > currentStepIndex
    ) {
      return;
    }

    try {
      const parsed = readLastStep();
      if (!parsed) return;
      const idx = findIndexByStepInfo(steps, parsed.type, parsed.seqByType);
      if (idx < 0) return;
      const query = parsed.q ? `?q=${parsed.q}` : "";
      const targetPath = `/v5-onboarding/${parsed.type}/${parsed.seqByType}${query}`;
      const currentPath = `/v5-onboarding/${type}/${id}${questionNumber ? `?q=${questionNumber}` : ""}`;
      if (currentPath === targetPath) return;
      navigate(targetPath, { replace: true });
    } catch (_) {
      // 파싱 실패 등은 무시
    }
  }, [
    type,
    id,
    questionNumber,
    steps,
    navigate,
    prevStepIndex,
    currentStepIndex,
  ]);

  const handleBack = () => {
    if (currentStepIndex <= 0) return;

    if (
      (currentStep.type === "convention" || currentStep.type === "habit") &&
      currentStep.seqByType === 2
    ) {
      if (questionNumber !== undefined && parseInt(questionNumber!!) > 1) {
        const prevQuestion = parseInt(questionNumber!!) - 1;
        navigate(
          `/v5-onboarding/${currentStep.type}/${currentStep.seqByType}?q=${prevQuestion}`
        );
      } else {
        const prevStep = steps[currentStepIndex - 1];
        navigate(`/v5-onboarding/${prevStep.type}/${prevStep.seqByType}`);
      }
      return;
    }

    if (currentStep.type === "convention" && currentStep.seqByType === 3) {
      navigate(
        `/v5-onboarding/${currentStep.type}/${currentStep.seqByType - 1}?q=10`
      );
      return;
    }

    if (currentStep.type === "habit" && currentStep.seqByType === 3) {
      navigate(
        `/v5-onboarding/${currentStep.type}/${currentStep.seqByType - 1}?q=5`
      );
      return;
    }

    const prevStep = steps[currentStepIndex - 1];
    navigate(`/v5-onboarding/${prevStep.type}/${prevStep.seqByType}`);
  };

  const { setProgress, setSectionCount } = useOnboardingProgress();

  useEffect(() => {
    if (currentStep.progressDelta) {
      let ratio = 1;
      if (questionNumber !== undefined && parseInt(questionNumber!!) > 0) {
        ratio = parseInt(questionNumber!!);
      }

      // 5개 섹션, 각 20%
      setSectionCount(5);
      if (currentStep.type === "demographic") {
        setProgress(0 + 20 * currentStep.progressDelta * ratio);
      } else if (currentStep.type === "goal") {
        setProgress(20 + 20 * currentStep.progressDelta * ratio);
      } else if (currentStep.type === "convention") {
        setProgress(40 + 20 * currentStep.progressDelta * ratio);
      } else if (currentStep.type === "habit") {
        setProgress(60 + 20 * currentStep.progressDelta * ratio);
      } else if (currentStep.type === "motivation") {
        let progress = 80 + 20 * currentStep.progressDelta * ratio;
        setProgress(Math.min(progress, 100)); // 100을 넘지 않도록
      }
    }
  }, [currentStep, questionNumber, setProgress]);

  if (currentStep.type === "product") {
    return (
      <div className="w-full h-full overflow-x-hidden">
        {<ProductContentPageV5 />}
      </div>
    );
  }

  return currentStep.centerFullScreen === true ? (
    <FullPageWithCenterContentV2
      content={currentStep.content}
      backgroundColor={currentStep.backgroundColor}
    />
  ) : (
    <FullPageWithHeaderAndProgressTmp
      headerTitle={currentStep.title}
      hideHeader={currentStep.hideHeader}
      hideProgress={currentStep.hideProgress}
      body={currentStep.content}
      highlightBackground={currentStep.highlightBackground}
      disableBack={false}
      onBack={currentStepIndex > 0 ? handleBack : undefined} // 첫 번째 단계에서는 뒤로가기 버튼 숨김
    />
  );
}
